var _path, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIExplorar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4897 14.898C18.232 14.898 18.967 14.7428 19.6527 14.4412C20.3385 14.1397 20.9616 13.6978 21.4864 13.1406C22.0113 12.5835 22.4276 11.922 22.7117 11.1941C22.9957 10.4661 23.1419 9.6859 23.1419 8.89796C23.1419 8.11003 22.9957 7.32982 22.7117 6.60186C22.4276 5.87391 22.0113 5.21247 21.4864 4.65532C20.9616 4.09817 20.3385 3.65622 19.6527 3.35469C18.967 3.05316 18.232 2.89796 17.4897 2.89796C15.9907 2.89796 14.553 3.53011 13.493 4.65532C12.4331 5.78054 11.8376 7.30667 11.8376 8.89796C11.8376 10.4893 12.4331 12.0154 13.493 13.1406C14.553 14.2658 15.9907 14.898 17.4897 14.898ZM23.4434 13.804L26.8158 17.384C26.9057 17.4763 26.9774 17.5867 27.0267 17.7087C27.076 17.8308 27.1019 17.962 27.1029 18.0948C27.1039 18.2276 27.08 18.3592 27.0325 18.4821C26.9851 18.6049 26.9151 18.7165 26.8265 18.8104C26.738 18.9042 26.6328 18.9784 26.517 19.0286C26.4012 19.0787 26.2771 19.104 26.1521 19.1027C26.027 19.1015 25.9034 19.0738 25.7885 19.0213C25.6736 18.9688 25.5697 18.8925 25.4829 18.797L22.1104 15.217C20.596 16.4648 18.6906 17.0531 16.782 16.8622C14.8735 16.6712 13.1052 15.7153 11.8371 14.189C10.5691 12.6628 9.89669 10.6809 9.95673 8.64689C10.0168 6.61287 10.8048 4.67959 12.1603 3.24061C13.5159 1.80163 15.3371 0.965131 17.2532 0.90139C19.1693 0.837649 21.0363 1.55146 22.4741 2.89752C23.9118 4.24357 24.8123 6.12068 24.9922 8.14672C25.1721 10.1728 24.6179 12.1954 23.4424 13.803L23.4434 13.804Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.397064,
    y: 0.897461,
    width: 8.34166,
    height: 2.39923,
    rx: 1.19961
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.397064,
    y: 8.33594,
    width: 6.08941,
    height: 2.39923,
    rx: 1.19961
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.397064,
    y: 15.7744,
    width: 8.34166,
    height: 2.39923,
    rx: 1.19961
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIExplorar);
export default __webpack_public_path__ + "static/media/i-explorar.c9ddccb87ba4b77e88a1e4caf0d6a977.svg";
export { ForwardRef as ReactComponent };